7
<template>
  <table class="table is-fullwidth">
    <thead>
    <tr>
      <th>id</th>
      <th>Site URL</th>
      <th>User ID</th>
      <th>Pref ID</th>
      <th>Created At</th>
    </tr>
    </thead>
    <tbody>
    <tr class="update" v-for="(rec, key) in records" @click="getRecord(key)" v-bind:key="key">
      <td class="content is-small">{{ rec.id }}</td>
      <td>{{ rec.site_url }}</td>
      <td>{{ rec.user_id }}</td>
      <td>{{ rec.pref_id }}</td>
      <td>{{ rec.create_at }}</td>
    </tr>
    </tbody>
  </table>
  <Record :record="record" v-on:close="record = null" v-if="record"></Record>
</template>

<script>
import Record from "./Record";
import {getUsageRecord, getUsageRecords} from "../../api/api";

export default {
  data() {
    return {records: [], record: null}
  },
  components: {Record},
  methods: {
    async getRecord(key) {
      try {
        const rec = await getUsageRecord(this.records[key].id).then(resp => resp.data)
        this.record = rec

      } catch (e) {
        console.error(e)
      }
    },
    async getRecords() {
      try {
        return await getUsageRecords().then(resp => resp.data)
      } catch (e) {
        console.error(e)

        return []
      }
    },
    async loadRecords() {
      this.records = await this.getRecords()
    }
  },
  async created() {
    await this.loadRecords()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.update {
  cursor: pointer;
}

</style>
